import { Loader, google } from "google-maps";

export abstract class GoogleMapsLoader {
  protected abstract loader: Loader;
  protected abstract googleLib: google | null;
  protected abstract load(): Promise<google>;
  abstract getGoogle(): Promise<google>;
}
